<template>
    <div id="business-work-hour" class="shadow-md rounded-item">
        <vx-card v-if="days_temp.length != 0">
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <div class="flex justify-end my-4 mx-6">
                        <vs-button color="primary" class="ml-6 gradient gradient-primary no-shadow" @click="getBusinessWorkingHour">Sync with business work hour</vs-button>
                    </div>
                    <div class="flex py-3 border border-solid border-dark border-t-0 border-r-0 border-l-0 mx-6">
                        <div class="w-1/6 text-center font-bold text-uppercase">Day</div>
                        <div class="w-1/3 text-center font-bold text-uppercase">In time</div>
                        <div class="w-1/3 text-center font-bold text-uppercase">Out Time</div>
                        <div class="w-1/6 text-center font-bold text-uppercase">Active</div>
                    </div>
                    <div v-for="(day, index) in days_temp" :key="index" class="m-6">
                        <div class="flex align-center">
                        <div class="w-1/6 text-uppercase font-bold">{{day.title}}</div>
                        <div class="w-1/3 flex-center" :class="{'is-invalid' : day.hasErr, 'inactive': !day.active}" >
                            <vue-timepicker format="hh:mm A" v-model="day.time[0]" :key="days.value" @on-change="setInTime($event, day)" v-validate="{required:true}" :name="day.time[0]"></vue-timepicker>
                        </div>
                        <div class="w-1/3 flex-center" :class="{'is-invalid': day.hasErr, 'inactive': !day.active}">
                            <vue-timepicker format="hh:mm A" v-model="day.time[1]" :key="days.value" @on-change="setOutTime($event, day)" v-validate="{required:true}" :name="day.time[1]"></vue-timepicker>
                        </div>
                        <div class="w-1/6 flex-center" @click="changeStatus(day)">
                            <vs-switch v-model="day.active" @click="switchActive(day)" />
                        </div>
                        </div>
                    </div>
                    <div class="flex justify-center py-6">
                        <vs-button type="filled" color="primary" @click="saveChanges" style="min-width: 140px">Save</vs-button>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import VueTimepicker from 'vue2-timepicker'
import "flatpickr/dist/flatpickr.css";
// import moment from "moment";

export default {
    name: 'booking-working-hour',
    components: {
        flatPickr,
        VueTimepicker
    },
    data() {
        let workingHourData = null;
        let working_day = '';
        let days = [];
        let working_day_temp = '';
        let days_temp = [];
        // let is_active = 0;
        return{
            workingHourData,
            working_day,
            days,
            working_day_temp,
            days_temp,
            configdateTimePicker: {
                enableTime: true,
                enableSeconds: false,
                noCalendar: true,
                dateFormat: "G:i K",
            },
            // is_active,
            hasErr: false,
            isOpenLoading: false,
            action_type: 'Get Data'
        }
    },
    methods:{
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#app",
                scale: 0.8
            });
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout(() => {
                if (this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: "danger",
                    title: "Notification",
                    text: this.action_type + " Failed",
                    acceptText: "OK"
                });
                }
            }, 10000);
        },
        closeLoading() {
            this.isOpenLoading = false;
            setTimeout(() => {
                this.$vs.loading.close("#app > .con-vs-loading");
            }, 500);
        },
        initData() {
            this.workingHourData = this.$store.getters["appSetting/bookingWorkingHour"];
            this.working_day = this.getWorkingDay(this.workingHourData);
            this.days = this.getDays(this.workingHourData);
            this.getWorkingHourDataTemp(this.working_day, this.days);
            // this.working_day = this.workingHourData.working_day ? this.workingHourData.working_day : '';
            // this.working_day_temp = this.working_day;
            // this.days = [
            //     {
            //         title: "Monday",
            //         time: [
            //             this.getInTime(this.workingHourData.mo),
            //             this.getOutTime(this.workingHourData.mo)
            //         ],
            //         value: 1,
            //         active: this.isActive(this.working_day, 1),
            //         hasErr: false,
            //     },
            //     {
            //         title: "Tuesday",
            //         time: [
            //             this.getInTime(this.workingHourData.tu),
            //             this.getOutTime(this.workingHourData.tu)
            //         ],
            //         value: 2,
            //         active: this.isActive(this.working_day, 2),
            //         hasErr: false,
            //     },
            //     {
            //         title: "Wednesday",
            //         time: [
            //             this.getInTime(this.workingHourData.we),
            //             this.getOutTime(this.workingHourData.we)
            //         ],
            //         value: 3,
            //         active: this.isActive(this.working_day, 3),
            //         hasErr: false,
            //     },
            //     {
            //         title: "Thursday",
            //         time: [
            //             this.getInTime(this.workingHourData.th),
            //             this.getOutTime(this.workingHourData.th)
            //         ],
            //         value: 4,
            //         active: this.isActive(this.working_day, 4),
            //         hasErr: false,
            //     },
            //     {
            //         title: "Friday",
            //         time: [
            //             this.getInTime(this.workingHourData.fr),
            //             this.getOutTime(this.workingHourData.fr)
            //         ],
            //         value: 5,
            //         active: this.isActive(this.working_day, 5),
            //         hasErr: false,
            //     },
            //     {
            //         title: "Saturday",
            //         time: [
            //             this.getInTime(this.workingHourData.sa),
            //             this.getOutTime(this.workingHourData.sa)
            //         ],
            //         value: 6,
            //         active: this.isActive(this.working_day, 6),
            //         hasErr: false,
            //     },
            //     {
            //         title: "Sunday",
            //         time: [
            //             this.getInTime(this.workingHourData.su),
            //             this.getOutTime(this.workingHourData.su)
            //         ],
            //         value: 0,
            //         active: this.isActive(this.working_day, 0),
            //         hasErr: false,
            //     }
            // ];
            // this.days_temp = JSON.parse(JSON.stringify(this.days));
        },
        getWorkingHourDataTemp(working_day, days) {
            this.working_day_temp = working_day;
            this.days_temp = JSON.parse(JSON.stringify(days));
        },
        getWorkingDay(workingHourData) {
            return workingHourData.working_day ? workingHourData.working_day : '';
        },
        getDays(workingHourData) {
            let working_day = workingHourData.working_day ? workingHourData.working_day : '';
            let days = [
                {
                    title: "Monday",
                    time: [
                        this.getInTime(workingHourData.mo),
                        this.getOutTime(workingHourData.mo)
                    ],
                    value: 1,
                    active: this.isActive(working_day, 1),
                    hasErr: false,
                },
                {
                    title: "Tuesday",
                    time: [
                        this.getInTime(workingHourData.tu),
                        this.getOutTime(workingHourData.tu)
                    ],
                    value: 2,
                    active: this.isActive(working_day, 2),
                    hasErr: false,
                },
                {
                    title: "Wednesday",
                    time: [
                        this.getInTime(workingHourData.we),
                        this.getOutTime(workingHourData.we)
                    ],
                    value: 3,
                    active: this.isActive(working_day, 3),
                    hasErr: false,
                },
                {
                    title: "Thursday",
                    time: [
                        this.getInTime(workingHourData.th),
                        this.getOutTime(workingHourData.th)
                    ],
                    value: 4,
                    active: this.isActive(working_day, 4),
                    hasErr: false,
                },
                {
                    title: "Friday",
                    time: [
                        this.getInTime(workingHourData.fr),
                        this.getOutTime(workingHourData.fr)
                    ],
                    value: 5,
                    active: this.isActive(working_day, 5),
                    hasErr: false,
                },
                {
                    title: "Saturday",
                    time: [
                        this.getInTime(workingHourData.sa),
                        this.getOutTime(workingHourData.sa)
                    ],
                    value: 6,
                    active: this.isActive(working_day, 6),
                    hasErr: false,
                    },
                {
                    title: "Sunday",
                    time: [
                        this.getInTime(workingHourData.su),
                        this.getOutTime(workingHourData.su)
                    ],
                    value: 0,
                    active: this.isActive(working_day, 0),
                    hasErr: false,
                }
            ];
            return days;
        },
        getBusinessWorkingHour() {
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/GET_BUSINESS_WORK_HOUR").then(() => {
                let working_day = this.getWorkingDay(this.$store.getters['appSetting/workingHour']);
                let days = this.getDays(this.$store.getters['appSetting/workingHour']);
                this.getWorkingHourDataTemp(working_day, days);
                this.closeLoading();
            }).catch((err) => {
                console.log('Error: ', err);
                this.closeLoading();
                this.$vs.dialog({
                color: 'danger',
                title: 'Notification',
                text: 'Get Business Hours Failed',
                acceptText: 'OK'
                })
            });
        },
        checkTime(t) {
            return t > 9 ? "" + t : "0" + t;
        },
        getInTime(time) {
            let num = 0;
            if(time) {
                num = parseInt(time.split(",")[0]);
            }
            let hour = 0;
            let A = "AM";
            if(Math.floor(num / 60) > 12) {
                hour = this.checkTime(Math.floor(num / 60) - 12);
                A = "PM";
            } else {
                if(Math.floor(num / 60) == 0) {
                hour = 12;
                } else if(Math.floor(num / 60) == 12) {
                hour = 12;
                A = "PM";
                } else {
                hour = this.checkTime(Math.floor(num / 60));
                }
            }
            let minute = this.checkTime(num % 60);
            let in_time = hour + ":" + minute + " " + A;
            return in_time;
        },
        getOutTime(time) {
            let num = 1;
            if(time) {
                num = parseInt(time.split(",")[1]);
            }
            let hour = 0;
            let A = "AM";
            if(Math.floor(num / 60) > 12) {
                hour = this.checkTime(Math.floor(num / 60) - 12);
                A = "PM";
            } else {
                if(Math.floor(num / 60) == 0) {
                    hour = 12;
                } else if(Math.floor(num / 60) == 12) {
                    hour = 12;
                    A = "PM";
                } else {
                    hour = this.checkTime(Math.floor(num / 60));
                }
            }
            let minute = this.checkTime(num % 60);
            let out_time = hour + ":" + minute + " " + A;
            return out_time;
        },
        getMinuteTime(in_time, out_time) {
            return this.getMinute(in_time) + ", " + this.getMinute(out_time);
        },
        isActive(day_string, value) {
            return typeof day_string == "string" && day_string.includes(value);
        },
        changeStatus(day) {
            if (this.isActive(this.working_day_temp, day.value)) {
                this.working_day_temp = this.working_day_temp.replace("," + day.value, "");
                this.working_day_temp = this.working_day_temp.replace(day.value + ",", "");
                this.working_day_temp = this.working_day_temp.replace(day.value, "");
            } else {
                this.working_day_temp = this.working_day_temp + "," + day.value;
            }
        },
        switchActive(day) {
            for (let i = 0; i < this.days_temp.length; i++) {
                if (day.value == this.days_temp[i].value) {
                    this.days_temp[i].active = day.active;
                }
            }
        },
        getMinute(time) {
            let in_minute = parseInt(time.split(":")[0]) * 60 + parseInt(time.split(":")[1]);
            if(time.includes('AM') && parseInt(time.split(":")[0]) == 12) {
                in_minute = parseInt(time.split(":")[1]);
            }
            if(time.includes('PM')) {
                if(parseInt(time.split(":")[0]) == 12) {
                    in_minute = parseInt(time.split(":")[0]) * 60 + parseInt(time.split(":")[1]);
                } else {
                    in_minute = (parseInt(time.split(":")[0]) + 12) * 60 + parseInt(time.split(":")[1]);
                }
            }
            return in_minute;
        },
        checkTimeInADay(day) {
            if(this.getMinute(day.time[0]) >= this.getMinute(day.time[1])) {
                return false;
            }
            return true;
        },
        checkValidTime() {
            for(let i = 0; i < this.days_temp.length; i++) {
                if(!this.checkTimeInADay(this.days_temp[i])) {
                    this.days_temp[i].hasErr = true;
                    this.hasErr = true;
                } else {
                    this.days_temp[i].hasErr = false;
                }
            }
        },
        hasEmptyTime() {
            for(let i = 0; i < this.days_temp.length; i++) {
                if(this.days_temp[i].time[0] == '' || this.days_temp[i].time[1] == ''){
                    return true;
                }
            }
            return false;
        },
        saveChanges() {
            this.checkValidTime();
            if(this.hasErr == false) {
                if(!this.isOpenLoading) {
                    this.openLoadingInDiv();
                }
                this.working_day = this.working_day_temp;
                this.days = JSON.parse(JSON.stringify(this.days_temp));
                const obj = {
                    type: 'booking',
                    working_day: this.working_day,
                    mo: this.getMinuteTime(this.days[0].time[0], this.days[0].time[1]),
                    tu: this.getMinuteTime(this.days[1].time[0], this.days[1].time[1]),
                    we: this.getMinuteTime(this.days[2].time[0], this.days[2].time[1]),
                    th: this.getMinuteTime(this.days[3].time[0], this.days[3].time[1]),
                    fr: this.getMinuteTime(this.days[4].time[0], this.days[4].time[1]),
                    sa: this.getMinuteTime(this.days[5].time[0], this.days[5].time[1]),
                    su: this.getMinuteTime(this.days[6].time[0], this.days[6].time[1]),
                    // is_active: this.is_active
                    is_active: this.workingHourData && this.workingHourData.is_active != null && this.workingHourData.is_active != undefined ? this.workingHourData.is_active : 1
                }
                this.action_type = "Update Booking Hours";
                this.$store.dispatch("appSetting/UPDATE_BUSINESS_WORK_HOUR", obj).then(() => {
                    this.closeLoading();
                    this.$vs.notify({
                        title:'Notification',
                        text:'Update Booking Hours Success',
                        color:'success',
                        position:'top-right'});
                })
            } else {
                this.$vs.notify({
                    title:'Notification',
                    text:'Check input time',
                    color:'danger',
                    position:'top-right'});
                this.hasErr = false;
            }
            this.$validator.validateAll().then((result) => {
                if(result == false) {
                    this.$vs.notify({
                        title:'Fail',
                        text:'Time is required',
                        color:'danger'
                    });
                }
            })
        },
    },
    created() {
        this.openLoadingInDiv();
        this.$store.dispatch("appSetting/GET_BOOKING_WORK_HOUR", {type: 'booking'}).then(() => {
            this.initData();
            this.closeLoading();
        })
    }
}
</script>